import { render, staticRenderFns } from "./RemoteJob.vue?vue&type=template&id=dc32cf32&scoped=true&"
import script from "./RemoteJob.vue?vue&type=script&lang=js&"
export * from "./RemoteJob.vue?vue&type=script&lang=js&"
import style0 from "./RemoteJob.vue?vue&type=style&index=0&id=dc32cf32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc32cf32",
  null
  
)

export default component.exports